export const ApplicationName = 'FlairPortal';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const LogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};

const prefix = '/authentication';
const authorizeBaseUrl = 'https://portal.open-connector.com';
//const authorizeBaseUrl = 'https://localhost:5005'; 

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/management',

  //ApiAuthorizationClientConfigurationUrl: `/_configuration/${ApplicationName}`,
  ApiAuthorizationClientConfiguration: {
    authority: `${authorizeBaseUrl}/`,
    client_id: 'FlairPortal',
    redirect_uri: `${authorizeBaseUrl}/authentication/login-callback`,
    post_logout_redirect_uri: `${authorizeBaseUrl}/authentication/logout-callback`,
    response_type: 'code',
    scope: 'openid profile email role nameid custom FlairPortal.WebAPI',
  },

  ApiAuthorizationPrefix: prefix,
  Login: `${prefix}/${LoginActions.Login}`,
  LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
  Register: `${prefix}/${LoginActions.Register}`,
  Profile: `${prefix}/${LoginActions.Profile}`,
  LogOut: `${prefix}/${LogoutActions.Logout}`,
  LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
  LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: '/Identity/Account/Register',
  IdentityManagePath: '/Identity/Account/Manage'
};
